import React from 'react';
import translate from '@/utils/translate';
import {BriefFieldManagerAttributes} from '@/views/campaigns/brief/brief-field-manager/BriefFieldManager';
import {CREATOR_COMPENSATION_TYPES} from '@/views/campaigns/brief/constants';
import styles from './CreatorPayments.module.scss';

const TRANSLATION_PREFIX =
  'components.campaign-brief.sections.creator-payments';

function CostText({title, description}: {title: string; description: string}) {
  return (
    <div className={styles.numberTextContainer}>
      <label className={styles.title}>{title}</label>
      <label className={styles.paymentDescription}>{description}</label>
    </div>
  );
}

interface PaymentRecapProps {
  briefFieldManager: BriefFieldManagerAttributes;
}
function PaymentRecap({briefFieldManager}: PaymentRecapProps) {
  const affiliateSalesCommissionRate = Number(
    briefFieldManager.fields.commissionRate.value
  );
  const fixedPrice = Number(
    briefFieldManager.fields.fixedCostForCreations.value
  );
  const suggestedPriceMax = Number(
    briefFieldManager.fields.suggestedCostForCreations.value
  );
  const suggestedPriceMin = Number(
    briefFieldManager.fields.suggestedCostForCreationsMin.value
  );

  const isAffiliateSales =
    briefFieldManager.fields.creatorCompensationAffiliateSales.value &&
    Number.isInteger(affiliateSalesCommissionRate);

  const isFixedPrice =
    briefFieldManager.fields.creatorCompensationDeliverables.value &&
    fixedPrice > 0 &&
    briefFieldManager.fields.creatorCompensationType.value ===
      CREATOR_COMPENSATION_TYPES.FIXED;

  const isSuggestedPrice =
    briefFieldManager.fields.creatorCompensationDeliverables.value &&
    suggestedPriceMax > 0 &&
    suggestedPriceMin > 0 &&
    briefFieldManager.fields.creatorCompensationType.value ===
      CREATOR_COMPENSATION_TYPES.RANGE;

  const isDeliverables = isSuggestedPrice || isFixedPrice;

  if (!isAffiliateSales && !isDeliverables) {
    return null;
  }

  const renderCost = () => {
    let deliverablesTitle = '';
    let deliverablesDescription = '';

    if (isSuggestedPrice) {
      deliverablesTitle = `$${suggestedPriceMin} - $${suggestedPriceMax}`;
      deliverablesDescription = translate(
        `${TRANSLATION_PREFIX}.suggested-range`
      );
    } else if (isFixedPrice) {
      deliverablesTitle = `$${fixedPrice}`;
      deliverablesDescription = translate(`${TRANSLATION_PREFIX}.fixed-price`);
    }

    return (
      <div className={styles.multiPaymentContainer}>
        {isDeliverables && (
          <CostText
            title={deliverablesTitle}
            description={deliverablesDescription}
          />
        )}
        {isAffiliateSales && isDeliverables && (
          <label className={styles.title}>+</label>
        )}
        {isAffiliateSales && (
          <CostText
            title={`$${affiliateSalesCommissionRate}%`}
            description={translate(`${TRANSLATION_PREFIX}.affiliate-sale`)}
          />
        )}
      </div>
    );
  };

  return (
    <div className={styles.paymentsRecap}>
      <div className={styles.paymentsRecapContent}>
        <label className={styles.paymentsRecapTitle}>
          {translate(`${TRANSLATION_PREFIX}.total-cost`)}
        </label>
        {renderCost()}
        {isAffiliateSales && !isDeliverables && (
          <label className={styles.paymentDescription}>
            {translate(`${TRANSLATION_PREFIX}.affiliate-sale-warning`)}
          </label>
        )}
      </div>
    </div>
  );
}

export default PaymentRecap;
